import React from "react";
import { 
    Box, 
    Typography, 
    IconButton, 
    Tooltip,
    Chip,
    Divider
} from "@mui/material";
import { 
    Add as AddIcon,
    Menu as MenuIcon,
    Schedule as ScheduleIcon
} from "@mui/icons-material";
import dayjs from "dayjs";
import ShikaLogo from "./ShikaLogo";

const ChatHeader = ({ 
    session, 
    onNewSession,
    onToggleSidebar,
    showSidebarToggle = false
}) => {
    const formatSessionInfo = () => {
        if (!session) return "New Session";
        
        const startTime = session.startedAt ? dayjs(session.startedAt).format("HH:mm") : "Now";
        const messageCount = session.messageCount || 0;
        
        return `Session started at ${startTime} • ${messageCount} messages`;
    };

    return (
        <Box sx={{ 
            display: "flex", 
            alignItems: "center", 
            justifyContent: "space-between",
            p: 2,
            borderBottom: 1,
            borderColor: "divider",
            backgroundColor: "background.paper"
        }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                {/* Sidebar Toggle for Mobile */}
                {showSidebarToggle && (
                    <>
                        <Tooltip title="Toggle sessions sidebar">
                            <IconButton onClick={onToggleSidebar} size="small">
                                <MenuIcon />
                            </IconButton>
                        </Tooltip>
                        <Divider orientation="vertical" flexItem />
                    </>
                )}

                {/* Session Info */}
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                    <ShikaLogo size={32} />
                    <Box>
                        <Typography variant="h6" component="div" sx={{ fontWeight: 'bold' }}>
                            Shika AI
                        </Typography>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 0.5 }}>
                            <ScheduleIcon sx={{ fontSize: 14, color: "text.secondary" }} />
                            <Typography variant="caption" color="text.secondary">
                                {formatSessionInfo()}
                            </Typography>
                            {session?.isActive && (
                                <Chip 
                                    label="Active" 
                                    size="small" 
                                    color="success" 
                                    variant="outlined"
                                    sx={{ 
                                        height: 18, 
                                        fontSize: "0.6rem",
                                        "& .MuiChip-label": { px: 0.5 }
                                    }}
                                />
                            )}
                        </Box>
                    </Box>
                </Box>
            </Box>

            {/* Actions */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Tooltip title="Start new session">
                    <IconButton 
                        onClick={onNewSession}
                        color="primary"
                        size="small"
                        sx={{
                            bgcolor: "primary.main",
                            color: "primary.contrastText",
                            "&:hover": {
                                bgcolor: "primary.dark"
                            }
                        }}
                    >
                        <AddIcon fontSize="small" />
                    </IconButton>
                </Tooltip>
            </Box>
        </Box>
    );
};

export default ChatHeader; 